export const MULTI_SELECT_BOX_TEST_IDS = {
  root: 'multi-select-box-root',
  input: 'multi-select-box-input',
  optionList: 'multi-select-box-option-list',
  option: (option: string) => `multi-select-box-option-${option}`,
  skeletonItem: 'multi-select-box-skeleton-item',
  noOptions: 'multi-select-box-no-options',
  disabledInfo: 'multi-select-box-disabled-info',
  chipContainer: 'multi-select-box-chip-container',
  chip: (option: string) => `multi-select-box-chip-${option}`,
  chipDeleteButton: (option: string) => `multi-select-box-chip-delete-${option}`
}

export const MULTI_SELECT_BOX_DEFAULT_MAX_LIST_HEIGHT = 320
